import { BACKEND_URL } from './utils';

const API_TIMEOUT = 10000;
const MAX_RETRIES = 3;
const RETRY_DELAYS = [1000, 2000, 4000];

export async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${BACKEND_URL}${path}`;
  let lastError;

  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT);

    try {
      const res = await fetch(url, { ...options, signal: controller.signal });
      clearTimeout(timeoutId);
      return res;
    } catch (err) {
      clearTimeout(timeoutId);
      lastError = err;

      if (err.name === 'AbortError') {
        lastError = new Error(`Request timed out after ${API_TIMEOUT / 1000}s`);
      }

      // Don't retry POST/PUT/DELETE to avoid duplicate actions
      if (options.method && options.method !== 'GET') throw lastError;

      if (attempt < MAX_RETRIES - 1) {
        await new Promise(r => setTimeout(r, RETRY_DELAYS[attempt]));
      }
    }
  }
  throw lastError;
}
